import { Outlet, useNavigate } from "react-router-dom";
import { Alert, AlertTitle, Box, Button, Stack, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import { useAuthStore } from "@/store/auth/auth.store";
import { useUserModulesStore } from "@/store/auth";

/**
 * Guard de acceso al modulo Tickets.
 *
 * Solo permite renderizar las rutas hijas (vista 360, my-ticket, masivos,
 * catalogos, etc.) si el usuario tiene AL MENOS un modulo
 * "TICKETS_SOPORTE_CLIENTES.*" habilitado en su perfil, o es superuser/staff
 * en Django.
 *
 * Antes, cualquier usuario podia entrar por URL directa y la pantalla
 * disparaba ~15 queries al microservicio ms-tickets que respondian 401.
 * El usuario quedaba en una pantalla rota con la consola llena de errores.
 * Ahora ese caso muestra una pantalla clara "Sin acceso" sin disparar
 * llamadas inutiles.
 */
const TicketClientesModule = () => {
  const navigate = useNavigate();
  const user = useAuthStore(s => s.user) as any;
  const userModules = useUserModulesStore(s => s.modules);

  // Superusers / staff de Django tienen acceso a todo el modulo
  // independientemente de la matriz user_modules.
  const isSuper = !!user?.is_superuser || !!user?.is_staff;
  const tieneAlgunModuloTickets = userModules.some(m =>
    m.startsWith("TICKETS_SOPORTE_CLIENTES.")
  );

  if (!isSuper && !tieneAlgunModuloTickets) {
    return (
      <Box sx={{ p: 3, maxWidth: 600, mx: "auto", mt: 6 }}>
        <Alert
          severity="warning"
          icon={<LockOutlinedIcon />}
          variant="outlined"
          sx={{ alignItems: "flex-start" }}
        >
          <AlertTitle sx={{ fontWeight: 700 }}>
            Sin acceso al modulo Tickets
          </AlertTitle>
          <Stack spacing={1.5} sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Tu usuario no tiene habilitado ninguno de los modulos del area
              de Tickets Soporte Cliente. Si necesitas acceso, solicitalo a
              un administrador desde{" "}
              <strong>/parametrizacion/gestion-accesos</strong>.
            </Typography>
            <Box>
              <Button
                variant="contained"
                size="small"
                startIcon={<HomeOutlinedIcon />}
                onClick={() => navigate("/")}
              >
                Volver al inicio
              </Button>
            </Box>
          </Stack>
        </Alert>
      </Box>
    );
  }

  return <Outlet />;
};

export default TicketClientesModule;
